import React, {Component} from 'react';
import BsyDialog from "../BsyDialog";
import AlertListSelectAppPopupPane from "../BsyAlertListDetail/selectAppPopupPane";
import BsyIconBtn from "../BsyIconBtn";

class CreateCustomizeKey extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form:null,
            formAuthList:[],
            auth:[]
        }
    }

    componentDidMount() {
        if(this.props.mode === "edit"){
            this.loadAuth()
        }
    }

    getPopupValue = (ref) =>{
        this.value = ref;
    }
    selectForm = (event) =>{
        let current = event.currentTarget
        BsyDialog({
            title: React.language("form.select"),
            height: 540,
            width: 720,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return <AlertListSelectAppPopupPane
                    onlyForm = {true}
                    webapi = {true}
                    appinfo ={this.props.mode === "edit" ? this.props.form.forminfo : {}}
                    noHome={true}
                    appid={this.state.appid}
                    info={this.state.form ? this.state.form : {}}
                    formid={this.state.formid}
                    getValue={this.getPopupValue} />
            },
            onOk: () => {
                if (!this.value) {
                    return false
                }
                if(this.value.forminfo.formType === "form" || this.value.forminfo.formType === "aggregate_table" || this.value.forminfo.formType === "etl_table"){
                    this.setState({
                        form:this.value,
                        appid:this.value.appinfo.appId,
                        formid:this.value.forminfo.formId,
                    },()=>{
                        this.loadAuth(this.value)
                    })
                }
            }
        })
    }

    loadAuth = (v) =>{
        if(this.props.mode === "create"){
            React.axios('/webapi/formauth',{formType:v.forminfo.formType,hasFlow:!v.forminfo.hasCoop}).then(res=>{
                this.setState({
                    formAuthList:res.data.appform
                })
            })
        }else if(this.props.mode === "edit"){
            if(v){
                React.axios('/webapi/formauth',{keyid:this.props.form.keyid,id:this.props.form.id,formType:v.forminfo.formType,hasFlow:!v.forminfo.hasCoop}).then(res=>{
                    let appform = res.data.appform;
                    this.value = v;
                    for(let i = 0;i<appform.length;i++){
                        appform[i].group.map(res1 => {
                            if(this.props.form.auth.indexOf(res1.key) > -1){
                                res1.select = true;
                            }
                        })
                    }
                    this.setState({
                        formAuthList:appform,
                        form:v ? v : this.value,
                        auth:this.props.form.auth,
                        appid:this.value.appinfo.appId,
                        formid:this.value.forminfo.formId
                    })
                })
            }else{
                React.axios('/webapi/formauth',{keyid:this.props.form.keyid,id:this.props.form.id,formType:this.props.form.info.forminfo.formType,hasFlow:!this.props.form.info.forminfo.hasCoop}).then(res=>{
                    let appform = res.data.appform;
                    this.value = this.props.form.info;
                    for(let i = 0;i<appform.length;i++){
                        appform[i].group.map(res1 => {
                            if(this.props.form.auth.indexOf(res1.key) > -1){
                                res1.select = true;
                            }
                        })
                    }
                    this.setState({
                        formAuthList:appform,
                        form:v ? v : this.value,
                        auth:this.props.form.auth,
                        appid:this.value.appinfo.appId,
                        formid:this.value.forminfo.formId
                    })
                })
            }
            
        }
    }

    checkAuth = (k1,k2) =>{
        return () => {
            const {formAuthList, auth} = this.state;
            let key = formAuthList[k1].group[k2].key;
            if(auth.indexOf(key) > -1){
                auth.splice(auth.indexOf(key),1);
                formAuthList[k1].group[k2].select = false;
            }else{
                auth.push(key);
                formAuthList[k1].group[k2].select = true;
            }
            this.setState({
                auth,formAuthList
            })
        }
    }

    onSave = () =>{
        const {form, auth} = this.state;
        if(!form){
            return
        }
        let data = {}
        data = {
            appId:form.appinfo.appId,
            formId:form.forminfo.formId,
            auth,
            info:form
        }

        this.props.getFormAuth && this.props.getFormAuth(data,this.props.mode,this.props.keyNum)
        this.props.elDom && this.props.elDom.closeAlter && this.props.elDom.closeAlter()
    }

    render() {
        const {form, formAuthList} = this.state
        return (
            <div className="CreateCustomizeKey">
                <div className="keyCont">
                    <div className="open-title"><span>{React.language('form.select')}</span></div>
                    <div className="open-cont">
                        {form ? <div className={"open-form-name"} onClick={this.selectForm}>
                                {form.appinfo && <>
                                    <div className="appName">
                                        <div className={`app-icon color-cover-${form.appinfo.style.color}`}>
                                            <div className={`imgbg-bby-app imgbg-bby-app-${form.appinfo.style.icon}`}/>
                                        </div>
                                        <span>{form.appinfo.name}</span>
                                    </div>
                                    <div className="line-center"/>
                                </>
                                }

                                <div className="formName" style={{marginLeft:form.appinfo ? "5px" : ""}}>
                                    <i className={`node-icon icon-bsy-${form.forminfo.formType}${!form.forminfo.hasCoop ? "-flow" : ""} ${form.forminfo.icon<=24?`icon-bsy-form-'${form.forminfo.icon}`:`icon-new-bsy-form-'${form.forminfo.icon}`}`}/>
                                    <span>{form.forminfo.name}</span>
                                </div>
                            </div> :
                            <div className={"open-form-name"}
                                 onClick={this.selectForm}>{
                                <span>{React.language('select.form')}</span>
                            }</div>}
                    </div>
                    {
                        (form && formAuthList.length > 0) && formAuthList.map((res,key)=>{
                            return <>
                                <div className="open-title"><span>{res.name}</span></div>
                                <div className="open-cont">
                                    {
                                        res.group.map((res1,key1)=>{
                                            return <div onClick={this.checkAuth(key, key1)}
                                                        className={"authCheckItem " + (res1.select ? "selected" : "")}>
                                                <i className={res1.select ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}/>
                                                <span>{res1.name}</span>
                                            </div>
                                        })
                                    }
                                </div>
                            </>
                        })
                    }
                </div>
                <div className="keyFooter">
                    <BsyIconBtn
                        text={React.language('save')}
                        click={this.onSave}
                        type={"blue"}
                        mode={window.mode}
                    />
                </div>
            </div>
        );
    }
}

export default CreateCustomizeKey;